/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
/* eslint-enable no-restricted-imports */
import React from "react";
import { createStyles } from "@material-ui/core/styles";
import type { StyleRules } from "@material-ui/core/styles/withStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { useI18n } from "hooks/i18n/i18n";
import { Button } from "components/atoms/button/Button";
import { pushDataLayerWithClientBuildUnixTime } from "utility/ga";

const styles: StyleRules = createStyles({
  buttonRoot: {
    width: "80vw",
    margin: "10px",
    color: "#fff",
    backgroundColor: "#000",
  },
});

type Props = {
  // classes: any;
  isSignup: boolean;
  // @ts-expect-error TS7006
  onClick: (provider) => void;
};
const GoogleLoginButton = (props: Props) => {
  const { isSignup } = props;
  const { t } = useI18n();
  const provider = new firebase.auth.GoogleAuthProvider();
  const actionText = isSignup
    ? t("login.buttons.registration")
    : t("login.buttons.login");

  const onClick = () => {
    props.onClick(provider);
    try {
      if (isSignup) {
        pushDataLayerWithClientBuildUnixTime({
          event: "spwn_begin_sign_up",
          method: "Google",
        });
      } else {
        pushDataLayerWithClientBuildUnixTime({
          event: "spwn_begin_login",
          method: "Google",
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Button
      text={`${t("login.loginMethod.google")}${actionText}`}
      color={"#d84437"}
      onClick={onClick}
    />
  );
};
export default withStyles(styles)(GoogleLoginButton);
